export default __webpack_public_path__ + "static/NCD-logo-main-8baf198a6efc6aca9f0c1cee3d04309c.png";